
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"move-folder"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.823 9.375H1.427m8.573-5V2.583a.708.708 0 00-.708-.708H4.375v-.542a.708.708 0 00-.708-.708H1.333a.71.71 0 00-.708.708v7.241a.802.802 0 001.576.206l1.11-3.892a.71.71 0 01.68-.513h6.55a.71.71 0 01.686.89L10.44 7.98m7.685 6.395v-1.792a.708.708 0 00-.708-.708h-4.292v-.542a.708.708 0 00-.708-.708h-2.334a.709.709 0 00-.708.708v7.241a.802.802 0 001.576.206l1.11-3.893a.71.71 0 01.68-.512h5.926a.71.71 0 01.685.89l-1.04 3.584a.709.709 0 01-.684.526h-7.451M15.625 1.25l-2.373 1.3L14.375 5","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.375 6.875a5.624 5.624 0 00-5.824-3.673M4.375 19.375l2.373-1.3-1.123-2.45m-5-1.875a5.627 5.627 0 005.825 3.673","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    